import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import API from "../../services/api";
import { toast } from "react-toastify";
import { successStatusCode } from "../../utils/constants";
const initialState = {
  category_classfication_data: [],
  form_Data: {
    firstName: { value: "", warning: false },
    lastName: { value: "", warning: false },
    phoneNumberCode: { value: "+44", warning: false },
    phoneNumber: { value: "", warning: false },
    email: { value: "", warning: false },
    category: { value: "", warning: false },
    classification: { value: "", warning: false },
    date: { value: "", warning: false },
    time: { value: "", warning: false },
    summary: { value: "", warning: false },
    personOfTreatment: { value: "", warning: false },
  },
  quickAddItemFormData: {
    item: { value: "", productId: "", warning: false },
    quantity: { value: "", warning: false },
    personOfTreatment: { value: "", warning: false },
    formDataArray: [],
  },
  injuryType: "single",
  quichReportData: null,
  nearMissFormData: {
    firstName: { value: "", warning: false },
    lastName: { value: "", warning: false },
    phoneNumberCode: { value: "+44", warning: false },
    phoneNumber: { value: "", warning: false },
    email: { value: "", warning: false },
    date: { value: "", warning: false },
    time: { value: "", warning: false },
    summary: { value: "", warning: false },
  },
  usersList: [],
};

const { GET_CATEGORY_CLASSFICATION, QUICKINCIDENTREPORT, GET_USERS } =
  ApiEndPoint;
export const QuickReport = createSlice({
  name: "QuickReport",
  initialState,
  reducers: {
    setFormDataQuickReport: (state, action) => {
      let data = { ...state };
      data = { ...data, ...data, form_Data: action.payload };
      return data;
    },
    setFormDataQuickReportItemAdd: (state, action) => {
      let data = { ...state };
      data = { ...data, ...data, quickAddItemFormData: action.payload };
      return data;
    },
    setSearchOperation: (state, action) => {
      state.quichReportData = action.payload;
    },
    setInjuryType: (state, action) => {
      state.injuryType = action.payload;
    },
    setFormDataNearMiss: (state, action) => {
      const copyForData = state.nearMissFormData ?? {};
      state.nearMissFormData = { ...copyForData, ...(action.payload ?? {}) };
    },
    // resetFormData: (state) => {
    //   state.form_Data = initialState.form_Data;
    //   state.quickAddItemFormData = initialState.quickAddItemFormData;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryClassificationData.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchCategoryClassificationData.fulfilled, (state, action) => {
        state.category_classfication_data = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchCategoryClassificationData.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      // post incident data
      .addCase(quickincidentdata.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(quickincidentdata.fulfilled, (state, action) => {
        state.status = StatusCode.IDLE;
        if (action?.payload?.status === successStatusCode) {
          // Reset form data after successful submission
          state.form_Data = initialState.form_Data;
          state.quickAddItemFormData = initialState.quickAddItemFormData;
        }
      })
      .addCase(quickincidentdata.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      // post incident near miss data
      .addCase(nearMissIncidentData.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(nearMissIncidentData.fulfilled, (state, action) => {
        state.status = StatusCode.IDLE;
        if (action?.payload?.status === successStatusCode) {
          // Reset form data after successful submission
          state.nearMissFormData = initialState.nearMissFormData;
        }
      })
      .addCase(nearMissIncidentData.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      .addCase(fetchUsers.pending, (state) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.usersList = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchUsers.rejected, (state) => {
        state.status = StatusCode.ERROR;
      });
  },
});

export const {
  setFormDataQuickReport,
  setFormDataQuickReportItemAdd,
  setSearchOperation,
  setInjuryType,
  setFormDataNearMiss,
  // resetFormData,
} = QuickReport.actions;
export default QuickReport.reducer;

export const fetchCategoryClassificationData = createAsyncThunk(
  "admin/get/kit",
  async () => {
    try {
      const res = await API.get(GET_CATEGORY_CLASSFICATION);
      if (res.data?.status === 200) {
        return res.data;
      }
    } catch (error) {
      console.error("Failed to fetch product management data:", error);
      throw error;
    }
  }
);

export const quickincidentdata = createAsyncThunk(
  "quick/incident/data",
  async (data) => {
    try {
      const res = await API.post(`${QUICKINCIDENTREPORT}`, data);
      return res?.data;
    } catch (error) {
      const errorMessage =
        error?.data?.message || "An error occurred on the server";
      toast.error(errorMessage);
    }
  }
);

export const fetchUsers = createAsyncThunk("admin/get/users", async (id) => {
  try {
    const res = await API.get(GET_USERS + `?company_id=${id}`);
    if (res.data?.status === 200) {
      return res.data?.data?.Users ?? [];
    }
  } catch (error) {
    console.error("Failed to fetch product management data:", error);
    throw error;
  }
});

export const nearMissIncidentData = createAsyncThunk(
  "near-miss/report/data",
  async (data) => {
    try {
      const res = await API.post(`${QUICKINCIDENTREPORT}`, data);
      return res?.data;
    } catch (error) {
      const errorMessage =
        error?.data?.message || "An error occurred on the server";
      toast.error(errorMessage);
    }
  }
);
